module.exports = __webpack_public_path__ + "static/media/20_galeria_plantillas_combo_duo_cuad_20.5417c2f3.png";